const VERSION = "/v1";

const URLS = {
    //Lass
    MFA: `${VERSION}/user/2fa-request/`,
    LOGIN: `${VERSION}/user/auth/`,
    FORGET_PASSWORD: `${VERSION}/user/password-reset/`,
    AMERINODE_FORGET_PASSWORD: `${VERSION}/user/amerinode/password-reset/`,
    PERMISSIONS: `${VERSION}/permission/own`,
    USER: `${VERSION}/user`,
    CUSTOMER: `${VERSION}/user`,
    SEPARATOR: `${VERSION}/user/separator`,
    LOCKER: `${VERSION}/locker`,
    ORGANIZATION: `${VERSION}/company/organization`,
    COUNTRIES: `${VERSION}/countries`,
    NOTICE: `${VERSION}/notice`,
    PERMISSION: `${VERSION}/permission`,
    ALLOCATION: `${VERSION}/allocation`,
    COMPANY_UUID: `${VERSION}/company`,
};

export default URLS;